export default __webpack_public_path__ + "static/media/art-1-main-md.bb232392.jpg";